import { render, staticRenderFns } from "./RecetaTable.vue?vue&type=template&id=27c1e22c"
import script from "./RecetaTable.vue?vue&type=script&lang=js"
export * from "./RecetaTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports